module.exports = __webpack_public_path__ + "static/img/shop.20672998.jpg";